<app-header></app-header>
<section>
    <router-outlet></router-outlet>
</section>
<app-footer class="mt-auto"></app-footer>
